var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-30-3H70v70H-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.759 4.759l1.377 1.377L8.527 32.744 7.15 31.367z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.833 18.333c0 5-4.233 8.5-8.833 8.5a9.131 9.131 0 01-5.885-2.149l-1.947 1.947a11.993 11.993 0 006.165 2.902V35h3.334v-5.467c5.466-.8 10-5.5 10-11.2h-2.834zm-18.011 6.89l1.96-1.959a8.184 8.184 0 01-1.615-4.931H8.333c0 2.593.944 4.981 2.489 6.89zm14.169-11.415l-8.288 8.288A4.98 4.98 0 0020 23.333a4.978 4.978 0 004.983-5l.008-4.525zm-9.483 6.729l9.487-9.487L25 8.333c0-2.766-2.233-5-5-5s-5 2.234-5 5v10a5 5 0 00.508 2.204z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio-off.322487d7d689796a12c6d724a4383b28.svg";
export { ForwardRef as ReactComponent };